"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensitivityPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const calculator_styles_1 = require("./calculator-styles");
const format_1 = require("./format");
const model_1 = require("./model");
const Strip = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(${model_1.SENSITIVITY_INTENSITIES.length}, 1fr);
  gap: 1px;
  background: ${theme_1.theme.colors.grey(4)};
  border: 1px solid ${theme_1.theme.colors.grey(4)};
  border-radius: 4px;
  overflow: hidden;

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const Cell = styled_components_1.default.div `
  background: ${(p) => p.$here ? theme_1.theme.colors.backgroundLightBlue : theme_1.theme.colors.white};
  padding: ${theme_1.theme.spacing(2)} ${theme_1.theme.spacing(2)};
  text-align: center;
`;
const Intensity = styled_components_1.default.div `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(-1)};
  color: ${theme_1.theme.colors.dimBlue};
`;
const Net = styled_components_1.default.div `
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(0)};
  margin-top: 3px;
  color: ${(p) => (p.$positive ? theme_1.theme.colors.green : theme_1.theme.colors.red)};
`;
const SecondaryNet = styled_components_1.default.div `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(-1)};
  margin-top: 1px;
  color: ${(p) => (p.$positive ? theme_1.theme.colors.dimBlue : theme_1.theme.colors.red)};
`;
const SensitivityPanel = ({ inputs }) => ((0, jsx_runtime_1.jsxs)(calculator_styles_1.Panel, { children: [(0, jsx_runtime_1.jsx)(calculator_styles_1.PanelTitle, { children: "Net result at other biofuel intensities" }), (0, jsx_runtime_1.jsxs)(calculator_styles_1.PanelBody, { children: [(0, jsx_runtime_1.jsx)(Strip, { children: model_1.SENSITIVITY_INTENSITIES.map((ciBio) => {
                        const row = (0, model_1.calculate)(inputs, ciBio);
                        return ((0, jsx_runtime_1.jsxs)(Cell, { "$here": Math.abs(ciBio - inputs.ciBio) < 0.5, children: [(0, jsx_runtime_1.jsxs)(Intensity, { children: [ciBio, " g/MJ"] }), (0, jsx_runtime_1.jsx)(Net, { "$positive": row.poolNet >= 0, children: (0, format_1.formatCompact)(row.poolNet) }), (0, jsx_runtime_1.jsx)(SecondaryNet, { "$positive": row.offsetNet >= 0, children: (0, format_1.formatCompact)(row.offsetNet) })] }, ciBio));
                    }) }), (0, jsx_runtime_1.jsx)(calculator_styles_1.Hint, { children: "Lower certified intensity means more surplus from the same tonnage. Bold is the net result pooling the surplus, below it the net result offsetting your own penalty instead." })] })] }));
exports.SensitivityPanel = SensitivityPanel;
